import Track from 'track/Track.js';

export function changeTrackLength(sequencerEngine, len) {
    len = Track.baseResolution
        .transformStepAtResolution2(len, sequencerEngine.resolution);
    let track = sequencerEngine.getSelectedTrack();
    track.pattern.changeLength(len);
    track.updateSteps();
}
